<template>
    <div v-if="totalPages > 1"
         class="paginator"
         :class="{
             'pager--has-next': !!nextPage,
             'page--has-prev': !!previousPage
         }">
        <a :class="{disabled: !previousPage}"
           class="btn btn-default"
           rel="prev"
           :href="urlForPage(previousPage) || '#'">
            <i class="glyphicon glyphicon-chevron-left"></i> Previous Page
        </a>

        <div class="paginator__pages-col">
            <a v-for="index in totalPages"
               :key="`page-link-${index}`"
               class="btn btn-default"
               :class="[currentPage === index ? 'btn-primary' : 'btn-default']"
               :href="urlForPage(index)">
                {{ index }}
            </a>
        </div>

        <a :class="{disabled: !nextPage}"
           class="btn btn-default"
           rel="next"
           :href="urlForPage(nextPage) || '#'">
            Next Page <i class="glyphicon glyphicon-chevron-right"></i>
        </a>
    </div>
</template>

<script>
export default {
    name: 'Pager',

    props: {
        totalPages: {
            type: Number,
            required: true,
        },

        currentPage: {
            type: Number,
            required: true,
        },

        url: {
            type: String,
            required: true,
        },
    },

    computed: {
        isOnLastPage() {
            return this.currentPage >= this.totalPages;
        },

        previousPage() {
            if (this.currentPage > 1) {
                return this.currentPage - 1;
            }

            return null;
        },

        nextPage() {
            const nextPage = this.currentPage + 1;

            return nextPage <= this.totalPages ? nextPage : null;
        },
    },

    methods: {
        urlForPage(page) {
            return this.url + page;
        },
    },
};
</script>
